import { Link } from "react-router-dom";
import { MapPin, Calendar, Clock, Trophy, Users, Globe2 } from "lucide-react";
import { formatDate, formatTime, toArray } from "@/lib/format";

export default function LiveEventCard({ event, index = 0, participantCount }) {
  const isLive = !event.isClosed;
  const orgs = toArray(event.organizaciones);
  const localCount = toArray(
    event.participantes || event.listaNombres
  ).length;
  const mcCount = participantCount ?? localCount;
  const city = event.city || event.ciudad || event.lugar;
  const country = event.country || event.pais;

  return (
    <Link
      to={`/evento/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="group fade-in-up relative flex flex-col gap-5 border border-[#1E293B] bg-[#0F172A] p-6 hover:border-[#FF5500]"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <div className="mb-2 flex items-center gap-2">
            {isLive ? (
              <span
                data-testid={`event-live-badge-${event.id}`}
                className="inline-flex items-center gap-1.5 bg-[#FF5500] px-2.5 py-1 font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-white"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-white live-pulse" />
                En vivo
              </span>
            ) : (
              <span className="inline-flex items-center gap-1.5 border border-[#1E293B] bg-[#080D1A] px-2.5 py-1 font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
                Finalizado
              </span>
            )}
            {event.modalidad && (
              <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
                {event.modalidad}
              </span>
            )}
          </div>
          <h3 className="font-display text-3xl leading-tight tracking-wide text-white group-hover:text-[#FF5500]">
            {event.titulo || "Sin título"}
          </h3>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 border-y border-[#1E293B] py-4">
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-[#FF5500]" />
          <span className="font-body text-sm text-white">
            {formatDate(event.fecha)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-[#FF5500]" />
          <span className="font-body text-sm text-white">
            {formatTime(event.hora)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-[#FF5500]" />
          <span className="font-body text-sm text-white">{city || "—"}</span>
        </div>
        <div className="flex items-center gap-2">
          {country ? (
            <>
              <Globe2 className="h-4 w-4 text-[#FF5500]" />
              <span className="font-body text-sm text-white">{country}</span>
            </>
          ) : (
            <>
              <Users className="h-4 w-4 text-[#FF5500]" />
              <span
                data-testid={`event-mc-count-${event.id}`}
                className="font-body text-sm text-white"
              >
                {mcCount} MC{mcCount === 1 ? "" : "s"}
              </span>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {country && (
            <span
              data-testid={`event-mc-count-${event.id}`}
              className="inline-flex items-center gap-1.5 font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]"
            >
              <Users className="h-3.5 w-3.5 text-[#FF5500]" />
              {mcCount} MC{mcCount === 1 ? "" : "s"}
            </span>
          )}
          {event.winner ? (
            <div className="flex items-center gap-2">
              <Trophy className="h-4 w-4 text-[#FF5500]" />
              <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
                Ganador
              </span>
              <span className="font-display text-base tracking-wider text-white">
                {event.winner}
              </span>
            </div>
          ) : (
            !country &&
            orgs.length > 0 && (
              <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#94A3B8]">
                {orgs.length} organización{orgs.length === 1 ? "" : "es"}
              </span>
            )
          )}
        </div>
        <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF5500] group-hover:underline">
          Ver detalle →
        </span>
      </div>

      {isLive && (
        <span className="pointer-events-none absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-[#FF5500] to-transparent opacity-60" />
      )}
    </Link>
  );
}
